package com.clany.backoffice.data.repository

import com.clany.backoffice.data.network.KeycloakConfig
import com.clany.backoffice.data.network.NetworkClient
import com.clany.backoffice.domain.repository.SubscriptionPlanRepository
import com.clany.backoffice.model.SubscriptionPlanResponse
import io.ktor.client.request.parameter
import io.ktor.http.ContentType
import io.ktor.http.contentType
import io.ktor.http.HttpMethod
import dev.zacsweers.metro.Inject
import dev.zacsweers.metro.ContributesBinding
import com.clany.backoffice.di.AppScope
import dev.zacsweers.metro.SingleIn

@SingleIn(AppScope::class)
@ContributesBinding(AppScope::class)
@Inject
class SubscriptionPlanRepositoryImpl(
    private val networkClient: NetworkClient
) : SubscriptionPlanRepository {

    private val baseUrl = KeycloakConfig.API_URL

    override suspend fun getSubscriptionPlans(page: Int, pageSize: Int, query: String?): Result<List<SubscriptionPlanResponse>> {
        return networkClient.request<List<SubscriptionPlanResponse>>("$baseUrl/api/subscription-plans") {
            parameter("page", page)
            parameter("limit", pageSize)
            if (query != null) parameter("q", query)
        }
    }

    override suspend fun getSubscriptionPlanById(id: String): Result<SubscriptionPlanResponse> {
        return networkClient.request<SubscriptionPlanResponse>("$baseUrl/api/subscription-plans/$id")
    }

    override suspend fun createSubscriptionPlan(plan: SubscriptionPlanResponse): Result<Unit> {
        return networkClient.request<Unit>("$baseUrl/api/subscription-plans", HttpMethod.Post, plan) {
            contentType(ContentType.Application.Json)
        }
    }

    override suspend fun updateSubscriptionPlan(id: String, plan: SubscriptionPlanResponse): Result<Unit> {
        return networkClient.request<Unit>("$baseUrl/api/subscription-plans/$id", HttpMethod.Put, plan) {
            contentType(ContentType.Application.Json)
        }
    }

    override suspend fun deleteSubscriptionPlan(id: String): Result<Unit> {
        return networkClient.request<Unit>("$baseUrl/api/subscription-plans/$id", HttpMethod.Delete)
    }

    override suspend fun refreshSubscriptionPlans(): Result<Unit> {
        return networkClient.request<Unit>("$baseUrl/api/subscription-plans/refresh", HttpMethod.Post)
    }
}
